// src/App.tsx

import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/global.css";
import ResultsPage from "./pages/results";
import Screening from "./pages/screening"; // Public patient-facing Screening Form
import SendScreen from "./pages/sendscreen";
import { useEffect } from "react";
import { addRumSessionAttributes } from "./providers/RumProvider";
import { getFormContext } from "./utils/rum-tracking";

function AppContent() {
  const location = useLocation();
  
  useEffect(() => {
    // Extract URL parameters from current location
    const currentSearchParams = new URLSearchParams(location.search);
    
    // If we have URL parameters, store them in sessionStorage
    if (currentSearchParams.toString()) {
      sessionStorage.setItem("searchParams", currentSearchParams.toString());
    }

    // Add form context to RUM session attributes
    const formContext = getFormContext();
    if (formContext.formId) {
      // Delay adding attributes to ensure RUM is initialized
      setTimeout(() => {
        addRumSessionAttributes({
          formId: formContext.formId || "unknown",
          saxId: formContext.saxId || "unknown",
          practiceId: formContext.practiceId || "unknown",
          tenantId: formContext.tenantId || "unknown",
        });
      }, 1000);
    }
  }, [location.search]);

  // Keep search params, if not present take them from session storage
  const searchParams = new URLSearchParams(
    location.search || sessionStorage.getItem("searchParams") || "",
  );
  
  // Check for required parameters - now more flexible to allow direct route access
  const ready =
    searchParams.has("parentLocation") &&
    searchParams.has("redirectUri") &&
    searchParams.has("formId");

  // If not ready and we're not on a direct route with parameters, show error
  if (!ready && !location.search) {
    console.error(
      "❌ Missing required query parameters in URL or sessionStorage",
    );
    // Redirect to the root with search params after a delay
    setTimeout(() => {
      const searchParamsFromStorage = sessionStorage.getItem("searchParams");
      const searchParams = searchParamsFromStorage
        ? new URLSearchParams(searchParamsFromStorage)
        : new URLSearchParams();
      window.location.href = `${process.env.REACT_APP_PUBLIC_URL}/?${searchParams.toString()}`;
    }, 1000);
    return null; // Prevent rendering if not ready
  }

  const params = searchParams.toString();
  
  // Render the application routes
  return (
    <main className="">
      <Routes>
        <Route element={<Screening />} path="/screening" />
        <Route element={<SendScreen />} path="/sendscreen" />
        <Route element={<ResultsPage />} path="/results" />
        <Route
          element={<Navigate replace to={`/screening?${params}`} />}
          path="*"
        />
      </Routes>
    </main>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
